<template>
    <el-container style="position: relative;padding-bottom: 50px; background: linear-gradient(to bottom, #aaaeb1, #eeeeee);">
        <el-aside width="200px" style="overflow: hidden;margin-bottom: 160px;background-color: #fff;">
            <menu-tree @handleSelect="changeSearch"></menu-tree>
        </el-aside>
        <el-container style="margin-bottom: 160px;height: auto;">
            <el-header class="message-header" style="height: auto;">
                {{ title }}
            </el-header>
            <el-main class="message-content">
                <!-- <div class="tab-wrap">
                    <ul class="tab-list clearfix">
                        <li
                            :class="['tab-item', { cur: item.tabId == curIdx }]"
                            v-for="(item, index) of tabData"
                            :key="index"
                            @click="selectionTab(index, item)"
                        >
                            {{ item.tabName }}
                        </li>
                    </ul>
                </div> -->
                <!-- <div v-show="curIdx == '20'"> -->
                <div>
                    <div class="message-operation" style="margin-bottom: 10px;">
                        <div style="display: flex;justify-self: center;">
                            <div size="mini" :class="{'selectType': status == 20,'font-12':true,}" @click="handleType(20)">未读</div>
                            <div size="mini" :class="{'selectType': status == 50,'font-12':true,}" @click="handleType(50)">已读</div>
                        </div>
                        <!-- <div style="margin-right: 20px;">
                            <el-popover
                                placement="right"
                                width="260"
                                v-model="filterPopover"
                                trigger="click">
                            <el-form :model="form" label-width="60px" size="mini" class="table-form">
                                <el-form-item label="发送人">
                                    <el-input v-model="searchtFrom.senderName"></el-input>
                                </el-form-item>
                                <el-form-item label="接收时间">
                                    <el-date-picker
                                        v-model="form.startDay"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                    >
                                    </el-date-picker>
                                    -
                                    <el-date-picker
                                        v-model="searchtFrom.endDay"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="结束日期"
                                        end-placeholder="结束日期"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                            </el-form>
                            <div class="filter-operation">
                                <el-button type="info" align="center" size="mini" @click="searchReset">刷新</el-button>
                                <el-button type="primary" align="center" size="mini" @click="searchOption">确定</el-button>
                            </div>
                            <el-button slot="reference" type="text" @click="" style="color: #606266;" align="center" size="mini">
                                <i class="el-icon-set-up"></i>筛选
                            </el-button>
                            </el-popover>
                        </div> -->
                    </div>
                    <div class="message-operation" style="border-bottom: 1px dashed #EBEEF5;">
                        
                        <el-form :model="form" label-width="60px" size="mini" class="table-form">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="发送人">
                                        <el-input v-model="searchtFrom.senderName" @keyup.enter.native="searchOption"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="16">
                                    <el-form-item label="接收时间" label-width="70px">
                                        <div style="display: flex;">
                                            <el-date-picker
                                                v-model="searchtFrom.startDay"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                range-separator="至"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                                @keyup.enter.native="searchOption"
                                            >
                                            </el-date-picker>
                                            <span style="margin: 0 10px;">-</span>
                                            <el-date-picker
                                                v-model="searchtFrom.endDay"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                range-separator="至"
                                                start-placeholder="结束日期"
                                                end-placeholder="结束日期"
                                                @keyup.enter.native="searchOption"
                                            >
                                            </el-date-picker>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                        <div style="margin-left: 10px;display: flex;">
                            <el-button type="primary" align="center" size="mini" @click="searchOption">查询</el-button>
                            <el-button align="center" size="mini" @click="searchReset">刷新</el-button>
                            <el-button type="primary" v-show="!showRadio" align="center" size="mini" @click="showRadio = true;selectBatchRead = []">批量已读</el-button>
                             <el-button type="primary" v-show="!showRadio" align="center" size="mini" @click="allReadConfirm">全部已读</el-button>
                            <el-button type="primary" v-show="showRadio" align="center" size="mini" @click="showRadio = false;">取消</el-button>
                            <el-button type="primary" v-show="showRadio" align="center" size="mini" @click="sureAllRead">确认已读</el-button>
                        </div>
                    </div>
                </div>
                 <div style="display: flex;align-items: start;margin-top: 10px;" v-if="showRadio" @click="selectAllItem">
                    <img src="../../assets/images/radioCircle.png" v-if="!selectAll" style="width: 14px;height: 14px;margin-right: 10px;margin-bottom: 4px;"></img>
                    <img src="../../assets/images/radioCircleSelect.png" v-if="selectAll" style="width: 14px;height: 14px;;margin-right: 10px;margin-bottom: 4px;"></img>
                    全选
                </div>
                <ul style="overflow: auto;padding-left: 0;">
                   
                    <li v-for="(item,index) in messageList" :key="index" class="message-list" @click="selectRead(item)">
                        <div style="display: flex;align-items: center;">
                            <img src="../../assets/images/radioCircle.png" v-if="showRadio && (selectBatchRead.findIndex(t => t === item.msgCode) === -1)" style="width: 14px;height: 14px;margin-right: 10px;margin-bottom: 4px;"></img>
                            <img src="../../assets/images/radioCircleSelect.png" v-if="showRadio && (selectBatchRead.findIndex(t => t === item.msgCode) !== -1)" style="width: 14px;height: 14px;;margin-right: 10px;margin-bottom: 4px;"></img>
                        </div>
                        <el-avatar v-if="item.picUrl"  :size="30" style="width: 34px;" :src="global.BASE_URL + item.picUrl"></el-avatar>
                        <el-avatar v-else :size="30" :style="{'background-color':item.backgroundColor,'width':'34px'}"> {{ item.senderName?item.senderName.substr(0,1):'系' }} </el-avatar>
                        <div class="message-list_right">
                            <div>
                                <!-- <span v-if="title === '会议'">
                                    <span class="list_right--name">{{ item.senderName?item.senderName:'系统' }}</span>
                                    邀请你参加<span class="list_right--name"> {{ dateFormat(item.beginDay) }}</span>
                                    至 <span class="list_right--name">{{ dateFormat(item.endDay) }}</span>的会议
                                </span> -->
                                <span>
                                    <span class="list_right--name">{{ item.msgTitle }}</span>
                                    <span class="list_right--message" v-if="item.msgType === 'meeting_message'">{{ item.msgBody }}</span>
                                </span>
                                <span class="list_right--detail" @click.stop="showDetail(item)"> 查看详情 </span>
                            </div>
                            <div class="list_right--time">
                                <span v-if="getWaitTime(item.createTime) !== ''">{{ getWaitTime(item.createTime) }}前</span>
                                <span v-else>一小时内</span>
                            </div>
                        </div>
                        <!-- <el-button v-show="status == 20" type="primary" align="center" size="mini" @click="sureRead(item)">标记已读</el-button> -->
                    </li>
                </ul>
                <el-dialog :visible.sync="detailVisible" title="消息详情">
                    <p>标题：{{ detailData.msgTitle }}</p>
                    <p>发送人：{{ detailData.senderName }}</p>
                    <p>发送时间：{{ detailData.createTime }}</p>
                    <p>消息内容：{{ detailData.msgBody }}</p>
                </el-dialog>
                <el-footer style="display: flex;justify-content: end;height: auto;">
                    <table-page
                        ref="messageListPage"
                        :url="messageListUrl"
                        :form="form"
                        :urlDafault="true"
                        @page-change="convert"
                    ></table-page>
                </el-footer>
            </el-main>
        </el-container>
        <div class="footCss"></div>
    </el-container>
</template>

<script>
import MenuTree from './components/menuTree.vue'
import TablePage from "@/components/TablePage";
import { encryptDes } from "@/utils/des";
import { convertDayHour,getUserColor } from '@/assets/common/common'
import Cookies from 'js-cookie'
import moment from 'moment';
import { redirectEncrypt } from '../../assets/common/redirectEncrypt';
export default {
    components:{
        MenuTree,
        TablePage,
    },
    mounted() {
        // 监听刷新消息列表事件
        this.$bus && this.$bus.$on('refreshMessageList', () => {
            this.search('refresh');
        });
    },
    beforeDestroy() {
        this.$bus && this.$bus.$off('refreshMessageList');
    },
    data(){
        return {
            curIdx: '50',
            tabData: [
                {
                    tabId: '20',
                    tabName: '未读'
                },
                {
                    tabId: '50',
                    tabName: '已读'
                }
            ],
            type: 'general',
            filterPopover: false,
            form: {msgTypes: [],status:'20'},
            messageListUrl: this.global.BASE_URL_2971 + "/msi/oa/message/findMessages",//this.global.BASE_URL_2971 + "/msi/cms/web/article/findWebArticle",
            messageList: [],
            searchtFrom:{msgTypes: [],status:'20'},
            detailVisible: false,
            detailData: {},
            title:'全部',
            status: 20,
            showRadio: false,
            selectBatchRead: [],
            selectAll:false,
        }
    },

    
    methods:{

        //批量已读，确认全部已读（不需要勾选，将所有数据标为已读）
        allReadConfirm() {
            this.$confirm('确定要将所有消息标记为已读吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
            }).then(() => {
            this.$axios.post(this.global.BASE_URL_2971 + "/msi/oa/message/allReadMessage")
                .then(res => {
                this.$message('全部消息已标记为已读');
                this.search();
                 this.$bus && this.$bus.$emit('refreshMessageCount');
                });
            }).catch(() => {});
        },
        selectAllItem(){
            console.log(this.messageList,'selectBatchRead')
            if(this.showRadio){
                this.selectAll = !this.selectAll
                if(this.selectAll){
                    this.messageList.forEach(item => {
                        if(this.selectBatchRead.findIndex(t => t === item.msgCode) === -1){
                            this.selectBatchRead.push(item.msgCode)
                        }
                    })
                }else{
                    this.messageList.forEach(item => {
                        let index = this.selectBatchRead.findIndex(t => t === item.msgCode)
                        this.selectBatchRead.splice(index,1)
                    })
                }
                console.log(this.selectBatchRead,'this.selectBatchRead')
            }
        },
        selectRead(item){
            if(this.showRadio){
                console.log(this.selectBatchRead.findIndex(t => t === item.msgCode),'this.selectBatchRead.findIndex(t => t === item.msgCode)')
                if(this.selectBatchRead.findIndex(t => t === item.msgCode) === -1){
                    this.selectBatchRead.push(item.msgCode)
                }else{
                    let index = this.selectBatchRead.findIndex(t => t === item.msgCode)
                    this.selectBatchRead.splice(index,1)
                }
            }
        },
        returnColor(){
            let colorList = ['#0cc0c9', '#ffab24', '#2e9cff', '#ff6952']
            let randomIndex = Math.floor(Math.random() * colorList.length)
            console.log(colorList[randomIndex],'colorList[randomIndex]')
            return colorList[randomIndex]
        },
        getWaitTime(time){
            let dataTime = {}
            let nowData = new Date().getTime()
            let lastData = new Date(time).getTime()
            dataTime = convertDayHour(nowData - lastData)
            return (dataTime.days > 0 ? dataTime.days + '天' : '') + (dataTime.hours > 0 ? dataTime.hours + '小时' : '')
        },
        dateFormat(date) {
            if (date) {
                return moment(date).format("YYYY-MM-DD HH:mm");
            }
            return "";
        },
        selectionTab (idx, val) {
            this.curIdx = val.tabId
            this.search()
        },
        handleType(status){
            this.status = status
            this.search()
        },
        searchReset() {
            delete this.searchtFrom.senderName
            delete this.searchtFrom.startDay
            delete this.searchtFrom.endDay
            this.filterPopover = false
            this.search()
        },
        changeSearch (index) {
            this.curIdx = index
            console.log(index,'index')
            this.form = {}
            this.searchtForm = {}
            if(index == 1){
                this.title = '全部'
                this.searchtFrom = {
                    msgTypes: []
                }
            }else if(index == 2){
                this.title = '日程'
                this.searchtFrom = {
                    msgTypes: []
                }
                this.searchtFrom.msgTypes.push('meeting_remind')
                this.searchtFrom.msgTypes.push('meeting_schedule')
                this.searchtFrom.msgTypes.push('schedule_remind ')
                this.searchtFrom.msgTypes.push('active_remind ')
            }else if(index == 3){
                this.title = '日报'
                this.searchtFrom = {
                    msgType: 'journal'
                }
            }else if(index == 4){
                this.title = '会议'
                this.searchtFrom = {
                    msgType: 'meeting_message'
                }
            }else if(index == 5){
                this.title = '审批中心'
                this.searchtFrom = {
                    msgTypes: []
                }
                this.searchtFrom.msgTypes.push('todo')
                this.searchtFrom.msgTypes.push('cc')
                this.searchtFrom.msgTypes.push('remind')
                this.searchtFrom.msgTypes.push('cb')
                this.searchtFrom.msgTypes.push('flow_error')
                this.searchtFrom.msgTypes.push('comment')  
            }else if(index == 6){
                this.title = '通知公告'
                this.searchtFrom = {
                    msgTypes: []
                }
                this.searchtFrom.msgTypes.push('article')
            }else if(index == 7){
                this.title = '收文'
                this.searchtFrom = {
                    msgTypes: []
                }
                this.searchtFrom.msgTypes.push('document')
            }
            this.search('refresh')
        },
        searchOption() {
            this.filterPopover = false
            this.search()
        },
        search(params) {
            this.form= {
                ...this.searchtFrom,
                status: this.status,
            }
            this.$nextTick(()=>{
                this.$refs["messageListPage"].getTableData(params);
            })
        },
        convert(tableData) {
            console.log(this.selectBatchRead,'this.selectAllItem')
            this.selectAll = false
            this.messageList = tableData.data.map(item => getUserColor(item));
        },
        sureRead(item){
            //未读的消息点击查看后，调用接口将消息状态改为已读
            let fromData = new FormData()
            fromData.append('msgCode', item.msgCode)
            this.$axios.post(this.global.BASE_URL_2971 + "/msi/oa/message/readMessage", fromData).then(res => {
                console.log(res)
                this.search()
                this.$bus && this.$bus.$emit('refreshMessageCount');
            })
        },
        sureAllRead(){
            this.$axios.post(this.global.BASE_URL_2971 + "/msi/oa/message/batchReadMessage", {data:this.selectBatchRead}).then(res => {
                this.$message('批量阅读完成')
                this.search()
                this.selectBatchRead = []
                this.showRadio = false
                this.$bus && this.$bus.$emit('refreshMessageCount');
            })
        },
        async getFlowUrlSeting(flowCode){
            const searchParams = window.location.search.substring(1).split('&');
            const params = {};
            for (const param of searchParams) {
            const [key, value] = param.split('=');
            params[key] = value;
            }
            let formData = {
            data:{
                flowCode:flowCode,
            }
            }
            let res =  await this.$axios.post(`${this.global.BASE_URL}/msi/flow/design/flow/findFlowConf`,formData,{
                headers: {
                'certificate':params.auth // 使用 Authorization 头部传递 token
                }
            })
            if(res.data.data){
            let resData = res.data.data
            if(resData.pcPageUrl){
                return resData.pcPageUrl
            }else{
                return ''
            }
            }
            return ''
        },
        async showDetail(item) {
            console.log(item.msgType,'msgType')
            // this.detailData = item;
            // this.detailVisible = true;
            // this.search()
            if(item.msgType === 'journal'){
                if(item.bizId){
                    let data = {
                        data:{
                            id:item.bizId
                        }
                    }
                    this.$axios.post(this.global.BASE_URL_2971 + "/msi/oa/journal/findOaJournalManagById", data).then(async(res) => {
                        console.log(res)
                        let userInfoId = JSON.parse(localStorage.getItem('user')).userInfoId
                        let todo = encryptDes(JSON.stringify(res.data.data))
                        if(userInfoId === res.data.data.createUserId){
                            let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/Daily?toDo='+todo +'&token=' + Cookies.get(`token_${window.location.port}`))
                            window.open(url,'_blank');
                            // window.open('http://localhost:3000/#/Daily?toDo='+todo,'_blank');
                        }else{
                            let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/noticeDaily?toDo='+todo +'&token=' + Cookies.get(`token_${window.location.port}`))
                            window.open(url,'_blank');
                            // window.open('http://localhost:3000/#/noticeDaily?toDo='+todo,'_blank');
                        }
                    })
                }else{
                    let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/Daily?toDo='+true +'&token=' + Cookies.get(`token_${window.location.port}`))
                    window.open(url,'_blank');
                }
                
            }else if(item.msgType === 'todo' || item.msgType === 'cc' || item.msgType === 'remind' || item.msgType === 'cb' || item.msgType === 'share' || item.msgType === 'flow_error' || item.msgType === 'comment'){
                let pageUrl = await this.getFlowUrlSeting(item.bizCode)
                let name = pageUrl.split('/')[pageUrl.split('/').length - 1]
                if(item.msgType === 'remind' || item.msgType === 'flow_error'){
                    let data = {
                        data:{
                            pageLocation:'List',
                            params:{},
                            processInstanceId:item.processId
                        },
                        pageIndex: 0,
                        pageSize: 10,
                    }
                    this.$axios.post(this.global.BASE_URL_2971 + "/msi/flow/engine/process/myProcess", data).then(async(res) => {
                        if(res.data.code === '0000'){
                            let todo = res.data.data[0]
                            todo.applyTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                            todo.createTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                            console.log(this.global.BASE_URL_2971+'/#/myApplyView?toDo='+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`))
                            if(pageUrl == ''){
                                let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/myApplyView?toDo='+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`))
                                window.open(url,'_blank');
                            }else{
                                let url = await redirectEncrypt(this.global.BASE_URL_2971+`/#/${name}View?toDo=`+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`))
                                window.open(url,'_blank');
                            }
                        }
                    })
                }else{
                    let data = {
                        data:{
                            processInstanceId:item.processId
                        }
                    }
                    this.$axios.post(this.global.BASE_URL_2971 + "/msi/flow/engine/process/findFlowJumpParam", data).then(async(res) => {
                        if(res.data.code === '0000'){
                            let form = res.data.data
                            let todo = res.data.data

                            let systemId = 0
                            let systemCode = ''
                            let typeName = res.data.data.typeName
                            if(['拜访管理','销售管理系统','流向管理','营销线考勤'].includes(typeName)){
                                systemId = 103
                                systemCode = 'saleSystem'
                            }else{
                                systemId = 1
                                systemCode = 'oaSystem'
                            }
                            if(form.processFlag === 'TODO'){
                                todo.id = form.taskId
                                todo.applyTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                                todo.createTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                                if(pageUrl == ''){
                                    let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/MyApprovalPend?toDo='+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode) 
                                    window.open(url,'_blank');
                                }else{
                                    let url = await redirectEncrypt(this.global.BASE_URL_2971+`/#/${name}Pend?toDo=`+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                                    window.open(url,'_blank');
                                }
                            }else if(form.processFlag === 'DONE'){
                                todo.applyTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                                todo.createTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                                if(pageUrl == ''){
                                    let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/MyApprovalView?toDo='+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                                }else{
                                    let url = await redirectEncrypt(this.global.BASE_URL_2971+`/#/${name}View?toDo=`+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                                    window.open(url,'_blank');
                                }
                            }else {
                                todo.formCode = todo.flowCode
                                todo.id = todo.processId
                                todo.nodeId = todo.activityId
                                todo.firstActivityId = todo.activityId
                                todo.bizCode = todo.formCode
                                todo.applyUserName = todo.applyUserName
                                todo.createUserName = todo.applyUserName
                                todo.createDeptName = todo.applyDeptName
                                todo.flowStatus = todo.status
                                todo.applyTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                                todo.createTime = moment(todo.createTime).format('yyyy-MM-DD HH:mm:ss')
                                if(pageUrl == ''){
                                    let url = await redirectEncrypt(this.global.BASE_URL_2971+'/#/myCopyView?toDo='+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                                    window.open(url,'_blank');
                                }else{
                                    let url = await redirectEncrypt(this.global.BASE_URL_2971+`/#/${name}View?toDo=`+encryptDes(JSON.stringify(todo))+'&token=' + Cookies.get(`token_${window.location.port}`)+'&systemId='+systemId+'&systemCode='+systemCode)
                                    window.open(url,'_blank');
                                }
                            }
                        }
                    })
                }
            }else if(item.msgType === 'schedule_remind' || item.msgType === 'active_remind'){
                window.open(this.global.BASE_URL_2971+'/#/oaSystem/schedulerCanlendar?toDo='+encryptDes(JSON.stringify(item)),'_blank');
            }else if(item.msgType === 'article'){
                const route = this.$router.resolve({ path: `/news/${item.bizId}`  });
                window.open(route.href, '_blank');
            }else if(item.msgType === 'document'){
                window.open(this.global.BASE_URL_2971+'/#/oaSystem/transceiverFileReading?toDo='+encryptDes(JSON.stringify(item)),'_blank');
            }else{
                let data = {
                    pageIndex: 0,
                    pageSize: 10,
                    data:{
                        bookingId: item.bizId
                    }
                }
                this.$axios.post(this.global.BASE_URL_2971 + "/msi/oa/meeting/myMeeting", data).then(res => {
                    if(res.data.code === '0000'){
                        let todo = res.data.data[0]
                        window.open(this.global.BASE_URL_2971+'/#/oaSystem/IJoinMeeting?toDo='+encryptDes(JSON.stringify(todo)),'_blank');
                    }
                })
                
            }
            this.sureRead(item)
            console.log(item)
        },

        deletMessage(item) {
            let fromData = new FormData()
            fromData.append('msgCode', item.msgCode)
            
            this.$axios.post(this.global.BASE_URL_2971 + "/msi/oa/message/deleteMessage", fromData).then(res => {
                console.log(res)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.message-header {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: #33383D;
    margin: 16px 16px 0;
    padding: 0 16px;
}
.font-12 {
    font-size: 12px;
    height: 20px;
    padding: 2px 10px !important;
}
.message-content {
    margin: 16px 16px 0;
    background-color: #fff;
    border-radius: 8px;

    .clearfix {
        content: "";
        display: table;
        clear: both;
    }
    .tab-wrap {
        display: flex;
    }
    .tab-list {
        width: 100%;
        margin-bottom: 16px;
        list-style: none;
        padding-left: 0px;
        margin: 0 0 16px 0;
    }
    .tab-item:first-child {
        margin-left: 0px;
    }
    .tab-item {
        float: left;
        height: 30px;
        line-height: 30px;
        margin-left: 40px;
        cursor: pointer;
        font-size: 14px;
    }
    .tab-item {
        color: #3d3533;
    }
    .tab-item.cur {
        color: #bb0009;
        border-bottom: 3px solid #bb0009;
    }

    .el-button {
        padding: 4px 7px;
    }
    .el-button:hover {
        color: #3d3533;
        background: rgba(255,157,138,.2);
        border-color: rgba(255,157,138,.2);
    }
    .selectType {
        // color: #fff;
        // background: #bb0009;
        // border-color: #bb0009;
        color: #bb0009;
        border: none;
        border-bottom: 2px solid #bb0009;
    }
    .message-operation {
        display: flex;
        justify-content: start;
        border: none;
        padding-bottom: 3px;

        .el-button {
            height: 26px;
        }
    }

    .message-list {
        color: #606266;
        font-size: 12px;
        line-height: 1.5;
        display: flex;
        padding-bottom: 12px;
        margin: 12px 0;
        border-bottom: 1px solid #ebeef5;;

        .message-list_right {
            padding-left: 20px;
            width: 100%;
            color: #606266;
            font-size: 14px;

            .list_right--name {
                color: #bb0009;
                margin-right: 5px;
            }

            .list_right--time {
                font-size: 10px;
                color: #a9b8bf;
            }

            .list_right--detail {
                color: #bb0009;
                margin-left: 5px;
            }
            .list_right--detail:hover {
                cursor: pointer;
            }
        }
    }
}
.footCss {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 146px;
  box-sizing: border-box;
  background: url(../../assets/images/red-footer-background.png) no-repeat;
  background-size: 100% 100%;
}
/deep/ .el-avatar>img {
    width: 32px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/message-center/index.vue